import { useState } from 'react'
import { useTheme } from '../theme'
import RinaContextCard from '../components/RinaContextCard'
import PageHub from '../components/PageHub'

function ContenuParametres() {
  const { isWeb3 } = useTheme()
  const { toggleTheme } = useTheme()
  const tc = 'text-ink'
  const ts = 'text-ink/60'
  const cardBg = 'bg-card border-card-border'

  const [langue, setLangue] = useState(() => localStorage.getItem('manrina_langue') || 'fr')
  const handleLangueChange = (newLangue) => {
    setLangue(newLangue)
    localStorage.setItem('manrina_langue', newLangue)
  }

  // Les notifications ont leur PROPRE page depuis la v7.4 (HubNotifications) :
  // le prototype en fait une entree de « Mon espace », plus une ligne de
  // reglage noyee ici.

  // Lignes de reglages — forme du prototype v7.3 (page generique du Compte) :
  // UNE carte de verre, une ligne par reglage, interrupteur 44x26 a droite.
  // `etat` : true/false = interrupteur · 'bientot' = fonctionnalite annoncee,
  // non proposee · null = ligne informative (chevron).
  const reglages = [
    {
      t: `Langue — ${langue === 'fr' ? 'Français' : 'Matinitje'}`,
      etat: null,
      onClick: () => handleLangueChange(langue === 'fr' ? 'cr' : 'fr'),
    },
    // Arbitrage Enzo (S31) : on n'offre pas encore le bouton flottant — il
    // promettrait une RINA qui agit, alors qu'elle ne fait que parler.
    { t: 'Bouton RINA flottant', etat: 'bientot' },
    { t: 'Mode sombre', etat: isWeb3, onToggle: toggleTheme },
  ]

  const Interrupteur = ({ actif }) => (
    <span className="w-11 h-[26px] rounded-full relative flex-shrink-0 transition-colors"
      style={{ background: actif ? 'rgb(var(--c-teal))' : 'rgba(7,62,61,0.18)' }}>
      <span className="absolute top-[3px] w-5 h-5 rounded-full bg-white transition-[left]"
        style={{ left: actif ? 21 : 3, boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
    </span>
  )

  return (
    <>
      {/* v7.2.4 : titre dans la bulle RINA — le retour vit dans le header */}
      <RinaContextCard
       
        title="Paramètres"
        message="Langue et apparence. Les notifications ont leur propre page."
      />

      <div className={`rounded-[22px] border overflow-hidden animate-fade-up ${cardBg}`}>
        {reglages.map((r, i) => {
          const cliquable = !!(r.onToggle || r.onClick)
          const Balise = cliquable ? 'button' : 'div'
          return (
            <Balise
              key={r.t}
              onClick={r.onToggle || r.onClick || undefined}
              className={`w-full flex items-center gap-3 px-4 py-[15px] text-left ${
                cliquable ? 'active:scale-[0.99] transition-transform' : ''
              } ${i > 0 ? `border-t ${isWeb3 ? 'border-white/5' : 'border-ink/[0.07]'}` : ''}`}
            >
              <span className="flex-1 min-w-0">
                <span className={`block text-sm font-semibold ${tc}`}>{r.t}</span>
                {r.sous && <span className={`block text-[11px] ${ts}`}>{r.sous}</span>}
              </span>
              {r.etat === 'bientot' ? (
                <span className="text-[10.5px] font-bold uppercase tracking-wider rounded-full px-2.5 py-1 flex-shrink-0"
                  style={{ color: 'rgb(var(--c-primary))', background: 'rgba(244,137,83,0.14)', border: '1px solid rgba(244,137,83,0.3)' }}>
                  Bientôt
                </span>
              ) : r.etat === null ? (
                <span className={`text-[13px] flex-shrink-0 ${ts}`}>›</span>
              ) : (
                <Interrupteur actif={r.etat} />
              )}
            </Balise>
          )
        })}
      </div>

      {/* Note 🦊 — meme patron que les pages generiques du prototype */}
      <div className={`rounded-2xl border mt-3.5 px-4 py-3 flex gap-2.5 items-start animate-fade-up ${cardBg}`}>
        <span className="text-[15px]">🦊</span>
        <p className={`text-xs leading-relaxed ${ts}`}>
          Le bouton RINA flottant sera surtout utile quand je pourrai agir pour vous —
          commander, composer un panier. En attendant, je vous parle depuis la carte
          en haut de chaque écran.
        </p>
      </div>
    </>
  )
}

// La page porte SON layout (S51) : retour et barre declares ici, la route
// d'App.jsx ne fait que router.
export default function PageParametres() {
  return <PageHub retour="account"><ContenuParametres /></PageHub>
}

